import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Card, Grid, Typography, Box, Link } from '@mui/material';
import { getAssetPath, sortByDate, sortByProperty } from 'app/utils/appHelpers';
import { ASSET_AVATARS, ASSET_IMAGES } from 'app/utils/constants/paths';
import { timeSince } from '@jumbo/utils';
import FeedItem from 'app/shared/widgets/DailyFeed/FeedItem';
import List from '@mui/material/List';
import { ANNOUNCEMENT } from 'app/utils/constants/customConstant';
import { getObjectListByPropertyApi } from 'api/general';
import { useEffect, useState } from 'react';
import AnnouncementItem from '../Item/AnnouncementItem';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function DashboardAnnouncementsCard({ }) {

    const [announcements, setAnnouncements] = useState([])
    const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts);
    const allAnnouncements = useSelector(state => state.general.announcements);
    const navigate = useNavigate();

    useEffect(() => {
        const getAPI = async () => {

            let data = allAnnouncements.filter(x => x.status === 1)
            data = sortByDate(data, "addedDate", "desc")
            if (allAuthorizedInsts.length > 0) {
                data = data.filter(x => {
                    const toAnnouncementArray = x.toAnnouncement ? x.toAnnouncement.split(',').map(item => item.trim()) : [];

                    return toAnnouncementArray.some(inst => allAuthorizedInsts.includes(inst));
                });
            }
            setAnnouncements(data)
        }
        getAPI()
    }, [])

    const handleViewAllAnnouncements = () => {
        navigate('/listAnnouncement');
    };

    return (

        <Card
            sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: 2,
                padding: '10px',
                maxHeight: '550px',
                minHeight: '385px',
                overflow: 'auto'

            }}
        >
            <JumboScrollbar
                autoHeight
                autoHeightMin={360}
                autoHeightMax={550}
                autoHide
                autoHideDuration={200}
                autoHideTimeout={500}
            >
                <Typography
                    sx={{ fontSize: '13px', padding: '5px', paddingBottom: '10px' }}
                >
                    Duyurular
                </Typography>
                <List disablePadding>
                    {
                        announcements.map((announcement, index) => (
                            <AnnouncementItem key={index} announcement={announcement} />
                        ))
                    }
                </List>

                {/* Tüm Duyurular Linki */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '10px 0',
                    borderTop: '1px solid #e0e0e0',
                    marginTop: '10px'
                }}>
                    <Link
                        component="button"
                        variant="body2"
                        onClick={handleViewAllAnnouncements}
                        sx={{
                            color: 'primary.main',
                            textDecoration: 'none',
                            fontSize: '12px',
                            fontWeight: 'medium',
                            cursor: 'pointer',
                            '&:hover': {
                                textDecoration: 'underline',
                                color: 'primary.dark'
                            }
                        }}
                    >
                        Tüm Duyurular
                    </Link>
                </Box>
            </JumboScrollbar>
        </Card>


    );
};

export default DashboardAnnouncementsCard